import React from "react";
import {Box, Grid, GridItem, Heading, Image, Text, useBreakpointValue, VStack} from "@chakra-ui/react";
import AboutMeImage from "../images/AboutMe.jpg";
import colors from "../colors";

function About({isDark}) {
    const gridTemplate = useBreakpointValue({
        base: "1fr",
        md: "1fr 1fr",
    });

    // Dynamic text colors
    const primaryText = isDark ? colors.brand[50] : colors.gray[700];
    const accentColor = isDark ? colors.teal[500] : colors.brand[500];
    const quoteBg = isDark ? colors.darkBg : colors.brand[60];
    const quoteBorder = isDark ? colors.teal[500] : colors.brand[500];
    const quoteText = isDark ? colors.teal[500] : colors.brand[500];

    return (
        <Box px={{base: 4, md: 8}} py={10}>
            <Grid
                templateColumns={gridTemplate}
                gap={10}
                mb={6}
                alignItems="center"
            >
                {/* Right Column (Image + quote) */}
                <GridItem
                    textAlign="center"
                    order={{base: 1, md: 3}} // 👈 Image first on mobile, second on desktop
                >
                    <Box
                        w={{base: "300px", md: "350px"}}
                        h={{base: "300px", md: "350px"}}
                        overflow="hidden"
                        borderRadius="full"
                        mx="auto"
                        mb={4}
                        boxShadow="md"
                    >
                        <Image
                            src={AboutMeImage}
                            alt="About Me"
                            objectFit="cover"
                            w="125%"
                            h="125%"
                            pointerEvents="none"
                            draggable="false"
                        />
                    </Box>

                    <Text fontSize="md" color={accentColor} fontStyle="italic" mt={2}>
                        "Work hard in silence [and] let success make the noise." - Frank Ocean
                    </Text>
                </GridItem>

                <GridItem
                    colSpan={{ base: 1, md: 2 }}
                    order={{ base: 2, md: 1 }}
                    textAlign="center"
                >
                    <Heading size="xl" color={accentColor}>
                        All About Tye
                    </Heading>
                </GridItem>

                {/* Left Column (Text content) */}
                <GridItem overflow="hidden" order={{base: 3, md: 2}}>
                    <VStack align="start" spacing={4} mx={"auto"}>
                        <Text fontSize="md" color={primaryText} whiteSpace="pre-line" textIndent="1.5em">
                            My name is Tyerra Sims but you can call me Tye. I am a software engineer and creative
                            designer
                            who loves turning ideas into engaging digital and physical experiences. From developing
                            responsive web applications to designing custom invitations, I bring together logic, design,
                            and
                            storytelling in everything I create.
                        </Text>
                        <Text fontSize="md" color={primaryText} whiteSpace="pre-line" textIndent="1.5em">
                            Outside of coding, I channel my creativity into designing custom invitations. I love how
                            both
                            design and development allow me to blend precision with personality — whether it’s a digital
                            interface or a special event keepsake.
                        </Text>
                        <Text fontSize="md" color={primaryText} whiteSpace="pre-line" textIndent="1.5em">
                            My journey started with a curiosity for how technology shapes experiences. What began as
                            experimenting with design layouts evolved into a passion for crafting full-fledged web
                            applications that are as functional as they are beautiful.
                        </Text>
                        <Text fontSize="md" color={primaryText} whiteSpace="pre-line" textIndent="1.5em">
                            When I’m not coding or designing, you’ll probably find me spending time with family and
                            close
                            friends, attending concerts, exploring new cities for adventures, or fine-tuning a playlist
                            that
                            keeps me inspired while I work.
                        </Text>
                    </VStack>
                </GridItem>
            </Grid>

            <Box
                as="blockquote"
                bg={quoteBg}
                p={6}
                mb={6}
                borderRadius="lg"
                borderLeft={`6px solid ${quoteBorder}`}
                fontStyle="italic"
                textAlign="center"
            >
                <Text fontSize="lg" color={quoteText}>
                    “For I know the plans I have for you,” declares the Lord, “plans to prosper you and not to harm you,
                    plans to give you a hope and a future.” — Jeremiah 29:11 (NIV)
                </Text>
            </Box>
        </Box>
    );
}

export default About;
